namespace Vit.Administration {
    export namespace TenantService {
        export const baseUrl = "Administration/Tenant";

        export declare function Create(request: Serenity.SaveRequest<TenantForm>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function Update(request: Serenity.SaveRequest<TenantForm>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<TenantForm>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<TenantRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Administration/Tenant/Create",
            Update = "Administration/Tenant/Update",
            Retrieve = "Administration/Tenant/Retrieve",
            Delete = "Administration/Tenant/Delete",
            List = "Administration/Tenant/List",
        }

        [
            "Create",
            "Update",
            "Retrieve",
            "Delete",
            "List",
        ].forEach(x => {
            (<any>TenantService)[x] = function (r, s, o) {
                return Q.serviceRequest(`${baseUrl}/${x}`, r, s, o);
            };
        });
    }
}
